import DOMPurify from 'dompurify';

const allowedTagsIndex: { [key: string]: { attributes?: Map<string, Set<string>> } } = {
  strong: {
    attributes: new Map(),
  },
  em: {
    attributes: new Map(),
  },
  span: {
    attributes: new Map(),
  },
  p: {
    attributes: new Map(),
  },
  u: {
    attributes: new Map(),
  },
  ul: {
    attributes: new Map(),
  },
  ol: {
    attributes: new Map([['start', null]]),
  },
  li: {
    attributes: new Map([['class', null]]),
  },
  h1: {
    attributes: new Map(),
  },
  b: {
    attributes: new Map(),
  },
  a: {
    attributes: new Map([['href', null], ['target', null]]),
  },
  br: {
    attributes: new Map(),
  },
  code: {
    attributes: new Map(),
  },
  del: {
    attributes: new Map(),
  },
};

const purifyConfig = {
  // This does not mean scripts are allowed.
  // This is allowed for dompurify (it won't strip it)
  // but our custom code will convert script into text node and hence
  // script won't execute
  ADD_TAGS: ['script'],
  FORCE_BODY: true,
  ADD_ATTR: ['target']
};

function sanitizeElement(element: HTMLElement): Node {
  if (element.nodeType === Node.ELEMENT_NODE) {
    const tagMetadata = allowedTagsIndex[element.tagName.toLowerCase()];

    if (tagMetadata) {

      Array.from(element.attributes).forEach((attribute) => {
        const attrName = attribute.name.toLowerCase();

        if (
          !tagMetadata.attributes.has(attrName) ||
          (tagMetadata.attributes.get(attrName) &&
            !tagMetadata.attributes.get(attrName).has(element.getAttribute(attrName).toLowerCase()))
        ) {
          element.removeAttribute(attrName);
        }
      });

      element.childNodes.forEach((childNode) => {
        const sanitizedNode = sanitizeElement(childNode as HTMLElement);

        if (sanitizedNode !== childNode) {
          element.replaceChild(sanitizedNode, childNode);
        }
      });

      return element;
    }

    return document.createTextNode(element.outerHTML);
  }

  return element;
}

/**
 * Sanitizes richText string by removing disallowed tag names, attributes, script callbacks.
 * @param richText HTML based rich text
 * @returns sanitized HTML based rich text
 */
export function sanitizeRichText(richText: string): string {
  richText = DOMPurify.sanitize(richText, purifyConfig);
  const div = document.createElement('span');
  div.innerHTML = richText;
  const sanitized = sanitizeElement(div);

  if (sanitized.nodeType === Node.TEXT_NODE) {
    return (sanitized as any).textContent;
  } else {
    return (sanitized as HTMLElement).innerHTML;
  }
}
